import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Spinner } from '@tsuyosa/ui';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MembersPage from './pages/MembersPage';
import MemberFormPage from './pages/MemberFormPage';
import NewsPage from './pages/NewsPage';
import NewsFormPage from './pages/NewsFormPage';
import BenefitsPage from './pages/BenefitsPage';
import BenefitFormPage from './pages/BenefitFormPage';
import SchedulePage from './pages/SchedulePage';
import ScheduleFormPage from './pages/ScheduleFormPage';
import ScheduleTypesPage    from './pages/ScheduleTypesPage';
import ScheduleTypeFormPage from './pages/ScheduleTypeFormPage';
import AssetsPage from './pages/AssetsPage';
import DiscographyPage     from './pages/DiscographyPage';
import DiscographyFormPage from './pages/DiscographyFormPage';
import ChekiOrdersPage     from './pages/ChekiOrdersPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/members" element={<ProtectedRoute><MembersPage /></ProtectedRoute>} />
      <Route path="/members/new" element={<ProtectedRoute><MemberFormPage /></ProtectedRoute>} />
      <Route path="/members/:id/edit" element={<ProtectedRoute><MemberFormPage /></ProtectedRoute>} />
      <Route path="/news" element={<ProtectedRoute><NewsPage /></ProtectedRoute>} />
      <Route path="/news/new" element={<ProtectedRoute><NewsFormPage /></ProtectedRoute>} />
      <Route path="/news/:id/edit" element={<ProtectedRoute><NewsFormPage /></ProtectedRoute>} />
      <Route path="/benefits" element={<ProtectedRoute><BenefitsPage /></ProtectedRoute>} />
      <Route path="/benefits/new" element={<ProtectedRoute><BenefitFormPage /></ProtectedRoute>} />
      <Route path="/benefits/:id/edit" element={<ProtectedRoute><BenefitFormPage /></ProtectedRoute>} />
      <Route path="/schedule" element={<ProtectedRoute><SchedulePage /></ProtectedRoute>} />
      <Route path="/schedule/new" element={<ProtectedRoute><ScheduleFormPage /></ProtectedRoute>} />
      <Route path="/schedule/:id/edit" element={<ProtectedRoute><ScheduleFormPage /></ProtectedRoute>} />
      <Route path="/schedule-types"          element={<ProtectedRoute><ScheduleTypesPage /></ProtectedRoute>} />
      <Route path="/schedule-types/new"      element={<ProtectedRoute><ScheduleTypeFormPage /></ProtectedRoute>} />
      <Route path="/schedule-types/:id/edit" element={<ProtectedRoute><ScheduleTypeFormPage /></ProtectedRoute>} />
      <Route path="/cheki-orders" element={<ProtectedRoute><ChekiOrdersPage /></ProtectedRoute>} />
      <Route path="/assets" element={<ProtectedRoute><AssetsPage /></ProtectedRoute>} />
      <Route path="/discography" element={<ProtectedRoute><DiscographyPage /></ProtectedRoute>} />
      <Route path="/discography/new" element={<ProtectedRoute><DiscographyFormPage /></ProtectedRoute>} />
      <Route path="/discography/:id/edit" element={<ProtectedRoute><DiscographyFormPage /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
